import { Component } from '@angular/core';

@Component({
  templateUrl: './sidebar.html'  
})
export class SidebarComponent { 

    constructor() { }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/sidebar/sidebar-component.ts